const templateDetail = () => import(/* webpackChunkName: "project-project" */ './list/templateDetail');

export default [
    {
        path: '/templateMana/templateDetail',
        name: 'templateDetail',
        component: templateDetail,
        meta: {
            guide: [
                {
                    path: '/templateMana/templateDetail',
                    title: '网页管理',
                },
                {
                    path: '/templateMana/1',
                    title: '模板管理',
                },
            ],
            access: {
                actionsCode: ['04202001'],
                includeOrg: [],
                outsideOrg: [],
            },
        },
    },
];
